import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import __ from "src/utils/Translations";

const ErrorPermissions: FC = () => (
  <Stack alignItems="center" spacing={2} mt="2rem">
    <svg
      width="420"
      height="251"
      viewBox="0 0 420 251"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M358.066 0.933838H60.5689C53.0899 0.933838 47.0269 7.67327 47.0269 15.9868V194.887C47.0269 203.2 53.0899 209.94 60.5689 209.94H358.066C365.545 209.94 371.608 203.2 371.608 194.887V15.9868C371.608 7.67327 365.545 0.933838 358.066 0.933838Z"
        fill="white"
      />
      <path
        d="M358.066 210.374H60.6081C52.92 210.374 46.6758 203.433 46.6758 194.887V15.9867C46.6758 7.44084 52.92 0.5 60.6081 0.5H358.066C365.754 0.5 371.998 7.44084 371.998 15.9867V194.887C371.998 203.433 365.754 210.374 358.066 210.374ZM60.6081 1.3676C53.3493 1.3676 47.4563 7.91802 47.4563 15.9867V194.887C47.4563 202.955 53.3493 209.506 60.6081 209.506H358.066C365.325 209.506 371.218 202.955 371.218 194.887V15.9867C371.218 7.91802 365.325 1.3676 358.066 1.3676H60.6081Z"
        fill="black"
      />
      <path
        d="M354.826 12.9932H63.8082C60.3596 12.9932 57.564 16.1007 57.564 19.934V190.895C57.564 194.729 60.3596 197.836 63.8082 197.836H354.826C358.275 197.836 361.071 194.729 361.071 190.895V19.934C361.071 16.1007 358.275 12.9932 354.826 12.9932Z"
        fill="white"
      />
      <path
        d="M354.827 198.314H63.8083C60.1398 198.314 57.1738 195.017 57.1738 190.939V19.9777C57.1738 15.8999 60.1398 12.603 63.8083 12.603H354.827C358.495 12.603 361.461 15.8999 361.461 19.9777V190.939C361.461 195.017 358.495 198.314 354.827 198.314ZM63.8083 13.4272C60.5691 13.4272 57.9544 16.3337 57.9544 19.9343V190.896C57.9544 194.496 60.5691 197.403 63.8083 197.403H354.827C358.066 197.403 360.681 194.496 360.681 190.896V19.9343C360.681 16.3337 358.066 13.4272 354.827 13.4272H63.8083Z"
        fill="black"
      />
      <path
        d="M344.055 176.32V34.5098C344.055 33.0723 343.007 31.907 341.714 31.907L76.96 31.907C75.6667 31.907 74.6184 33.0723 74.6184 34.5098V176.32C74.6184 177.757 75.6667 178.923 76.96 178.923L341.714 178.923C343.007 178.923 344.055 177.757 344.055 176.32Z"
        fill="#EAEAEA"
      />
      <path
        d="M392.096 250.066H26.5772C17.6012 250.066 9.40567 247.203 5.65916 242.735L0.390625 236.488H418.244L412.975 242.735C409.229 247.203 401.033 250.066 392.057 250.066H392.096Z"
        fill="white"
      />
      <path
        d="M392.097 250.5H26.5773C17.5232 250.5 9.17158 247.593 5.38604 243.039L0.117501 236.792C0.000422755 236.662 0.0004299 236.488 0.0394561 236.315C0.117508 236.141 0.234585 236.054 0.390689 236.054H418.244C418.4 236.054 418.556 236.141 418.595 236.315C418.673 236.488 418.595 236.662 418.517 236.792L413.249 243.039C409.424 247.55 401.112 250.5 392.057 250.5H392.097ZM1.28829 236.965L5.93241 242.475C9.60087 246.856 17.7183 249.676 26.5773 249.676H392.097C400.955 249.676 409.073 246.856 412.741 242.475L417.386 236.965H1.28829Z"
        fill="black"
      />
      <path
        d="M418.244 236.575H0.390625L61.3495 209.592H357.324L418.244 236.575Z"
        fill="white"
      />
      <path
        d="M418.244 237.008H0.390262C0.195131 237.008 0.0390262 236.878 0 236.661C0 236.444 0.0780547 236.271 0.234159 236.184L61.154 209.202C61.1931 209.202 61.2321 209.202 61.3101 209.202H357.285C357.324 209.202 357.402 209.202 357.441 209.202L418.361 236.184C418.517 236.271 418.634 236.444 418.595 236.661C418.595 236.878 418.4 237.008 418.205 237.008H418.244ZM2.41963 236.141H416.175L357.207 210.026H61.3882L2.41963 236.141Z"
        fill="black"
      />
      <path
        d="M296.17 232.757H122.503L147.831 221.522H270.842L296.17 232.757Z"
        fill="#EAEAEA"
      />
      <path
        d="M288.014 71.6869H125.743V100.101H288.014V71.6869Z"
        fill="white"
      />
      <path
        d="M151.305 71.6869H125.743V100.101H151.305V71.6869Z"
        fill="#2196F3"
      />
      <path
        d="M143.251 82.5348C143.881 79.5737 142.232 76.6058 139.568 75.9057C136.903 75.2057 134.233 77.0387 133.604 79.9998C132.974 82.9609 134.623 85.9288 137.287 86.6289C139.951 87.3289 142.622 85.4959 143.251 82.5348Z"
        fill="white"
      />
      <path
        d="M144.397 96.0232V93.8975C144.397 90.2102 141.666 87.1736 138.348 87.1736C135.031 87.1736 132.299 90.2102 132.299 93.8975V96.0232H144.397Z"
        fill="white"
      />
      <path
        d="M167.736 92.5959C170.43 92.5959 172.614 90.1682 172.614 87.1734C172.614 84.1786 170.43 81.7509 167.736 81.7509C165.041 81.7509 162.857 84.1786 162.857 87.1734C162.857 90.1682 165.041 92.5959 167.736 92.5959Z"
        fill="#EAEAEA"
      />
      <path
        d="M180.536 92.5959C183.23 92.5959 185.415 90.1682 185.415 87.1734C185.415 84.1786 183.23 81.7509 180.536 81.7509C177.842 81.7509 175.657 84.1786 175.657 87.1734C175.657 90.1682 177.842 92.5959 180.536 92.5959Z"
        fill="#EAEAEA"
      />
      <path
        d="M193.453 92.5959C196.148 92.5959 198.332 90.1682 198.332 87.1734C198.332 84.1786 196.148 81.7509 193.453 81.7509C190.759 81.7509 188.575 84.1786 188.575 87.1734C188.575 90.1682 190.759 92.5959 193.453 92.5959Z"
        fill="#EAEAEA"
      />
      <path
        d="M206.644 92.5959C209.339 92.5959 211.523 90.1682 211.523 87.1734C211.523 84.1786 209.339 81.7509 206.644 81.7509C203.95 81.7509 201.766 84.1786 201.766 87.1734C201.766 90.1682 203.95 92.5959 206.644 92.5959Z"
        fill="#EAEAEA"
      />
      <path
        d="M220.187 92.5959C222.881 92.5959 225.066 90.1682 225.066 87.1734C225.066 84.1786 222.881 81.7509 220.187 81.7509C217.492 81.7509 215.308 84.1786 215.308 87.1734C215.308 90.1682 217.492 92.5959 220.187 92.5959Z"
        fill="#EAEAEA"
      />
      <path
        d="M288.014 110.729H125.743V139.143H288.014V110.729Z"
        fill="white"
      />
      <path
        d="M151.305 110.729H125.743V139.143H151.305V110.729Z"
        fill="#2196F3"
      />
      <path
        d="M168.243 130.467C170.937 130.467 173.121 128.039 173.121 125.044C173.121 122.049 170.937 119.622 168.243 119.622C165.548 119.622 163.364 122.049 163.364 125.044C163.364 128.039 165.548 130.467 168.243 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M181.043 130.467C183.738 130.467 185.922 128.039 185.922 125.044C185.922 122.049 183.738 119.622 181.043 119.622C178.349 119.622 176.165 122.049 176.165 125.044C176.165 128.039 178.349 130.467 181.043 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M193.961 130.467C196.656 130.467 198.84 128.039 198.84 125.044C198.84 122.049 196.656 119.622 193.961 119.622C191.267 119.622 189.083 122.049 189.083 125.044C189.083 128.039 191.267 130.467 193.961 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M207.152 130.467C209.846 130.467 212.03 128.039 212.03 125.044C212.03 122.049 209.846 119.622 207.152 119.622C204.457 119.622 202.273 122.049 202.273 125.044C202.273 128.039 204.457 130.467 207.152 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M220.694 130.467C223.388 130.467 225.572 128.039 225.572 125.044C225.572 122.049 223.388 119.622 220.694 119.622C217.999 119.622 215.815 122.049 215.815 125.044C215.815 128.039 217.999 130.467 220.694 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M234.743 130.467C237.438 130.467 239.622 128.039 239.622 125.044C239.622 122.049 237.438 119.622 234.743 119.622C232.049 119.622 229.865 122.049 229.865 125.044C229.865 128.039 232.049 130.467 234.743 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M247.544 130.467C250.239 130.467 252.423 128.039 252.423 125.044C252.423 122.049 250.239 119.622 247.544 119.622C244.85 119.622 242.666 122.049 242.666 125.044C242.666 128.039 244.85 130.467 247.544 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M260.462 130.467C263.156 130.467 265.34 128.039 265.34 125.044C265.34 122.049 263.156 119.622 260.462 119.622C257.767 119.622 255.583 122.049 255.583 125.044C255.583 128.039 257.767 130.467 260.462 130.467Z"
        fill="#EAEAEA"
      />
      <path
        d="M135.461 124.177L135.539 119.969C135.539 118.624 136.67 117.496 138.037 117.41C139.559 117.323 140.808 118.538 140.769 120.056V124.351C140.769 124.828 142.447 124.958 142.447 124.524L142.33 120.143C142.408 117.713 140.456 115.761 137.958 115.891C135.89 115.978 133.977 117.8 133.899 120.013L133.821 124.264L135.422 124.177H135.461Z"
        fill="white"
      />
      <path
        d="M138.076 134.675C141.198 134.675 144.086 132.506 143.774 128.168V123.396C143.735 123.005 143.462 122.745 143.15 122.745H133.782C133.314 122.745 132.924 123.179 132.924 123.699V128.992C133.002 132.202 135.227 134.675 138.076 134.675Z"
        fill="white"
      />
      <path
        d="M138.348 131.248C138.621 131.248 138.817 130.987 138.817 130.727V126.476C138.817 126.215 138.621 125.999 138.387 125.999C138.114 125.999 137.919 126.259 137.919 126.519V130.77C137.919 131.031 138.114 131.248 138.348 131.248Z"
        fill="#3B98D4"
      />
      <path
        d="M136.787 126.866C136.748 127.864 137.412 128.688 138.309 128.688C139.207 128.688 139.988 127.864 140.027 126.866C140.066 125.869 139.402 125.044 138.505 125.044C137.607 125.044 136.826 125.869 136.787 126.866Z"
        fill="#3B98D4"
      />
      <path
        d="M362.866 141.789C362.866 138.318 360.368 135.542 357.246 135.542C354.124 135.542 351.626 138.318 351.626 141.789C351.626 145.259 352.797 146.214 354.553 147.255V159.314C354.553 160.963 355.763 162.308 357.246 162.308C358.729 162.308 359.939 160.963 359.939 159.314V147.255C361.695 146.214 362.866 144.131 362.866 141.789Z"
        fill="white"
      />
      <path
        d="M405.912 44.5988H308.58C300.814 44.5988 294.531 51.2218 294.531 59.4082V157.479C294.531 173.153 302.843 187.509 316.112 194.626L359.002 217.745L399.238 194.832C412.039 187.551 420 173.441 420 158.137V59.4082C420 51.2218 413.717 44.5988 405.951 44.5988H405.912Z"
        fill="#2196F3"
      />
      <path
        d="M321.576 183.313C312.327 178.336 306.59 168.463 306.59 157.52V59.4491C306.59 58.2972 307.487 57.3922 308.541 57.3922H405.872C406.965 57.3922 407.824 58.3384 407.824 59.4491V158.178C407.824 168.833 402.282 178.624 393.384 183.684L358.729 203.388L321.498 183.313H321.576Z"
        fill="white"
      />
      <path
        d="M385.072 118.856H330.241C328.172 118.856 326.494 120.625 326.494 122.805V140.165C326.494 154.975 337.89 166.987 351.939 166.987H363.335C377.384 166.987 388.78 154.975 388.78 140.165V122.805C388.78 120.625 387.102 118.856 385.033 118.856H385.072Z"
        fill="#102B3F"
      />
      <path
        d="M364.239 134.943C364.239 131.465 361.558 128.639 358.258 128.639C354.958 128.639 352.276 131.465 352.276 134.943C352.276 138.422 353.514 139.4 355.37 140.487V152.661C355.37 154.291 356.608 155.704 358.258 155.704C359.805 155.704 361.145 154.4 361.145 152.661V140.487C363.002 139.4 364.239 137.335 364.239 134.943Z"
        fill="white"
      />
      <path
        d="M379.452 113.75C378.203 113.75 377.15 112.681 377.15 111.323V103.178C377.15 93.6342 369.774 85.8593 360.72 85.8593H353.695C344.641 85.8593 337.265 93.6342 337.265 103.178V111.323C337.265 112.64 336.25 113.75 334.962 113.75C333.674 113.75 332.66 112.681 332.66 111.323V103.178C332.66 90.9603 342.065 81.0463 353.656 81.0463H360.68C372.271 81.0463 381.677 90.9603 381.677 103.178V111.323C381.677 112.64 380.662 113.75 379.374 113.75H379.452Z"
        fill="#102B3F"
      />
    </svg>

    <Typography variant="h4" textAlign="center">
      403
    </Typography>
    <Typography variant="h5" textAlign="center">
      {__("Brak uprawnień")}
    </Typography>
    <Typography textAlign="center">
      {__("Nie masz uprawnień do przeglądania tej strony. ")}
    </Typography>
    <Typography textAlign="center">
      {__("Skontaktuj się z administratorem lub wróć na stronę główną.")}
    </Typography>
  </Stack>
);

export default ErrorPermissions;
